import utils from 'Helpers/utils';

export default {
    name: 'app-dialog',
    props: {
        beforeCancel: {
            type: Function,
        },
        width: undefined,
        title: '',
        lastEditedDate: '',
        isActionDisabled: Boolean,
        isShowActionButtons: {
            default: true,
            type: Boolean,
        },
    },
    data() {
        return {
            dialogOpen: false,
        };
    },
    methods: {
        open(formRef, editedIndex) {
            if (this.$parent.$refs[formRef] && !utils.isEditAction(editedIndex)) {
                this.$parent.$refs[formRef].$refs.form.resetValidation();
            }
            this.dialogOpen = true;
        },
        close() {
            this.dialogOpen = false;
        },
        cancel() {
            // if (typeof this.beforeCancel === 'function') {
            //     this.beforeCancel();
            // }
            this.$emit('cancel', this.close);
        },
        confirmAction() {
            this.$emit('confirmAction', this.close);
        },
    },
    computed: {
        getWidth() {
            if (this.$props.width) {
                return this.$props.width;
            }
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return 220;
                case 'sm':
                    return 400;
                case 'md':
                    return 500;
                case 'lg':
                    return 600;
                case 'xl':
                    return 800;
            }
        },
    },
};
